<template>
  <layout-main-inner title="原料管理">
    <div slot="action">
      <safety-stocks-info-btn />
    </div>
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <!-- <template
        v-if="userPermission.ENT"
        slot="title">
        <create-prod-btn />
      </template> -->
      <template slot="form">
        <!-- <assign-ent-select
          v-if="userPermission.SUPERVISE || userPermission.OPERATE"
          v-model="config.vendorId"
          immediate
          style="margin-right: 10px"
          :option="{}"
          :callback="() => {handleCurrentChange(1)}" /> -->
        <el-radio-group
          v-model="config.productTypes"
          style="margin-right: 10px"
          @change="handleCurrentChange(1)">
          <el-radio-button :label="[2, 3]">全部</el-radio-button>
          <el-radio-button :label="[2]">包材</el-radio-button>
          <el-radio-button :label="[3]">散茶</el-radio-button>
        </el-radio-group>
        <el-input
          v-model="config.productName"
          placeholder="请输入原料名称"
          clearable
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        stripe
        :data="list">
        <el-table-column
          label="原料名称"
          :resizable="false"
          prop="productName">
        </el-table-column>
        <el-table-column
          label="原料编号"
          width="160"
          :resizable="false"
          prop="productNumber">
        </el-table-column>
        <el-table-column
          label="商品类别"
          width="80"
          :resizable="false"
          prop="productTypeName">
        </el-table-column>
        <el-table-column
          label="单位"
          :resizable="false"
          width="50"
          prop="measureUnit">
          <template slot-scope="{row}">
            {{ row.measureUnit | measureUnitName() }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          :resizable="false"
          width="125">
          <template slot-scope="{row}">
            <el-button
              type="warning"
              @click.native="setsafetystock(row)">
              安全库存配置
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <safety-stocks-modal
      ref="stocks"
      :edit="true" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import SafetyStocksModal from './busi/safety-stocks-modal.vue'
import SafetyStocksInfoBtn from './busi/safety-stocks-info-btn.vue'
export default {
  name: 'RawMaterials',
  components: { SafetyStocksModal, SafetyStocksInfoBtn },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        productTypes: [2, 3],
        productName: '',
        status: 2
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission,
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    setsafetystock(row) {
      this.loading = true
      this.$store.dispatch('product/getsafetystocks', {
        payload: {
          productId: row.productId,
          pageNum: 1,
          pageSize: 10000
        },
        success: (res) => {
          this.loading = false
          this.$refs.stocks.fetch({
            productId: row.productId,
            productName: row.productName,
            list: res.data.records,
            productType: row.productType,
            measureUnit: row.measureUnit
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('product/getproducts', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              measureUnitName: i.measureUnit === 12 ? '件' : '克',
              productTypeName: i.productType === 2 ? '包材' : '散茶'
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
